import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
    maxWidth: '1440px',
    padding: '0 16px',
  },

  copyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 20,
      height: 20,
    },
  },
  copyIconSmall: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 15,
      height: 15,
    },
  },
}))
